import React, { FC, useEffect, useState } from "react";
import { useDispatchEx, useSelectorEx } from "../../hooks/redux";
import Preloader from "../molecules/Preloader/Preloader";
import { useParams } from "react-router-dom";
import {
    asyncCreateFinanceAction,
    asyncDeleteFinanceAction,
    asyncGetFinancesAction,
    asyncUpdateFinanceAction
} from "../../redux/slices/finance/financeAction";
import { setCurrentPageFinance } from "../../redux/slices/finance/financeSlice";
import FinanceList, { FinanceFilters } from "../molecules/FinanceList/FinanceList";
import { IFinance } from "../../helpers/types";
import StatisticsItems from "../molecules/StatisticsItems/StatisticsItems";

const FinanceContainer: FC = () => {
    const { isLoading, finances, totalFinances, currentPage } = useSelectorEx(
        state => state.finance
    );
    const { pageNumber } = useParams();
    const dispatch = useDispatchEx();

    const [filters, setFilters] = useState<FinanceFilters>({
        transaction_type: "TRANSFER",
        name: "",
        city: "",
        purchase_currency: "",
        author: "",
        dateFrom: "",
        dateTo: ""
    });

    useEffect(() => {
        const newPageNumber = pageNumber ? Number(pageNumber) : 1;

        dispatch(
            asyncGetFinancesAction({
                page: newPageNumber,
                transaction_type: filters.transaction_type,
                name: filters.name,
                city: filters.city,
                purchase_currency: filters.purchase_currency,
                author: filters.author,
                dateFrom: filters.dateFrom,
                dateTo: filters.dateTo
            })
        );
        dispatch(setCurrentPageFinance(newPageNumber));
    }, [pageNumber, dispatch, filters]);

    const onPagination = (page: number) => {
        dispatch(
            asyncGetFinancesAction({
                page,
                transaction_type: filters.transaction_type,
                name: filters.name,
                city: filters.city,
                purchase_currency: filters.purchase_currency,
                author: filters.author,
                dateFrom: filters.dateFrom,
                dateTo: filters.dateTo
            })
        );
        dispatch(setCurrentPageFinance(page));
    };

    const onDelete = (id: number): Promise<void> => {
        return dispatch(asyncDeleteFinanceAction(id))
            .unwrap()
            .then(() => {});
    };

    const onCreate = (data: Partial<IFinance>): Promise<void> => {
        return dispatch(asyncCreateFinanceAction(data))
            .unwrap()
            .then(() => {});
    };

    const onUpdate = (id: number, data: Partial<IFinance>): Promise<void> => {
        return dispatch(asyncUpdateFinanceAction({ id, data }))
            .unwrap()
            .then(() => {});
    };

    const handleChangeFilters = (newFilters: FinanceFilters) => {
        setFilters(newFilters);
    };

    //if (isLoading) return <Preloader />;

    return (
        <>
            {isLoading && <Preloader />}
            <StatisticsItems type={filters.transaction_type}/>
            <FinanceList
                items={finances}
                totalCount={totalFinances}
                currentPage={currentPage}
                onChangePagination={onPagination}
                onDelete={onDelete}
                onCreate={onCreate}
                onUpdate={onUpdate}
                pageUrl={`/admin/finance`}
                filters={filters}
                onChangeFilters={handleChangeFilters}
            />
        </>

    );
};

export default FinanceContainer;
